exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "chaos-monkey-config-footer .footer {\n  padding: 10px 0 0 0;\n  border-top: 1px solid var(--color-alto);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/application/config/footer/configSectionFooter.component.less
// module id = 2499
// module chunks = 0